import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { OpenDataCommercial } from '@/components/Logo/OpenDataCommercial';
import { PermissionGate } from '@/core/auth/PermissionGate/PermissionGate';
import { paths } from '@/core/router/paths';
import { Permission } from '@/core/store/auth/auth.types';

import { OpenDataCommercialMobileLogo } from '../../components/Logo/OpenDataCommercialMobileLogo';
import { HeaderSearchBar } from '../SearchAndFilters/HeaderSearchBar/HeaderSearchBar';

import { useHeaderStyles as useStyles } from './Header.styles';
import { HeaderMenu } from './HeaderMenu/HeaderMenu';

type Props = {
	displayLogo?: boolean;
	displaySearchBar?: boolean;
};

export const Header = ({
	displayLogo = true,
	displaySearchBar = true
}: Props) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobileDevice = useMediaQuery(theme.breakpoints.down(650)); // Intentionaly using hardcoded number as breakpoint

	const sx = useStyles({ displayLogo, displaySearchBar });

	return (
		<AppBar elevation={0} position='fixed' sx={sx.root}>
			<Container maxWidth='xl' disableGutters sx={sx.headerContainer}>
				<Box sx={sx.logoContainer}>
					{displayLogo && (
						<Link
							component={RouterLink}
							to={paths.home}
							sx={sx.appLogoContainer}
							underline='none'
							aria-label='Home'
						>
							{isMobileDevice ? (
								<OpenDataCommercialMobileLogo sx={sx.appLogoMobile} />
							) : (
								<OpenDataCommercial sx={sx.appLogo} monoChrome />
							)}
						</Link>
					)}
				</Box>

				<Box>{displaySearchBar && <HeaderSearchBar />}</Box>

				<Box sx={sx.rightContainer}>
					<PermissionGate permission={Permission.DcrEnabled}>
						<Button
							component={RouterLink}
							to={paths.dcrs}
							sx={sx.dcrLink}
							aria-label={'My DCR button'}
						>
							{t('My DCRs')}
						</Button>
					</PermissionGate>
					<HeaderMenu />
				</Box>
			</Container>
		</AppBar>
	);
};
